/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroupText,
  InputGroup,
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as MyAPI from '../../../utils/MyAPI'

// GenerateDictionaryModal
const GenerateDictionaryModal = (props) => {

  let [dictionaryNameKey, setDictionaryNameKey] = useState("")
  let [isPublic, setIsPublic] = useState(true)

  let _toggleIsPublic = () => {

    if (isPublic === true) {
      setIsPublic(false)
    } else {
      setIsPublic(true)
    }
  }


  // create new monitoring word list
  let _generateNewDictionary = async () => {

    props.setLoading(true)

    try {

      if (!dictionaryNameKey) {
        throw Error("名前をつけてください。")
      }
      
      let _results = await MyAPI.createNewMonitoringWordList({
        login_token: props.login_token,
        word_list_name: dictionaryNameKey,
        is_public: isPublic,
      })

      if (_results.status === "error") {
        throw Error(_results.message)
      }

      props.showAlert("作成しました", "success")

      props.closeModal()

    } catch (err) {
      console.log("err: ", err)
      props.showAlert(err.message, "error")
    }
    props.setLoading(false)
  }

  return (
      <Modal isOpen={props.isOpen} toggle={props.closeModal}>
        <ModalHeader toggle={props.closeModal}>
          <span>
            モニタリングワードリストを作成
          </span>
        </ModalHeader>
        <ModalBody>

        <div>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" style={{
              lineHeight: '36px',
            }}>
              名前:
            </Col>
            <Col md="8" xs="12">

              <Input
                type="text"
                style={{
                  width: '100%',
                }}
                name='dictionaryNameKeyq'
                onChange={(e) => setDictionaryNameKey(e.target.value)}
                value={dictionaryNameKey}
                placeholder='' />
            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="4" xs="12" style={{
              lineHeight: '36px',
            }}>
              共有可能範囲:
            </Col>
            <Col md="8" xs="12">

              <FontAwesomeIcon
                onClick={_toggleIsPublic}
                icon={isPublic === true ? "toggle-on" : "toggle-off"}
                style={{
                  marginTop: 12,
                  cursor: 'pointer',
                  marginRight: 6,
              }}/>

              {isPublic === true ? (
                <span>
                  パブリック
                </span>
              ) : (
                <span>
                  プライベート
                </span>
              )}

            </Col>
          </Row>

          <Row style={{
            marginTop: 20,
            marginBottom: 20,
          }}>
            <Col md="12" xs="12" style={{
              textAlign: 'right',
            }}>
              <Button
                onClick={_generateNewDictionary}
                color="success"
                style={{
                  cursor: 'pointer',
                }}>
                ワードリストを作成する
              </Button>
            </Col>

          </Row>


        </div>

        </ModalBody>
      </Modal>
  );
}

export default GenerateDictionaryModal;
